import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue";
var _hoisted_1 = {
  class: "exercise-container-title flex"
};
var _hoisted_2 = {
  class: "exercise-container-title-left"
};
var _hoisted_3 = {
  class: "exercise-time"
};
var _hoisted_4 = {
  key: 0,
  class: "nested"
};
var _hoisted_5 = ["innerHTML"];
var _hoisted_6 = {
  class: "exercise-container-tags"
};
import { EXERCISE_TYPE_NAME } from '@/const/enum';
import publicProps from './props';
export default {
  __name: 'NoType',
  props: publicProps,
  setup: function setup(__props) {
    var props = __props;
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass({
          'no-type': true,
          'exercise-container': true,
          'is-nested': props.isNested
        })
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [!props.isNested ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass({
          flex: !props.isApp
        })
      }, [_createElementVNode("div", {
        class: _normalizeClass({
          'exercise-type': true,
          'margin-b': props.isApp
        })
      }, _toDisplayString(_unref(EXERCISE_TYPE_NAME)[props.type]), 3), _createElementVNode("div", {
        class: _normalizeClass({
          flex: props.isApp
        })
      }, [_createElementVNode("span", _hoisted_3, _toDisplayString(props.data._createTime), 1), _createElementVNode("span", null, _toDisplayString(props.data.fromWhere), 1)], 2)], 2)) : _createCommentVNode("", true)]), _renderSlot(_ctx.$slots, "handle")]), _createElementVNode("div", {
        class: _normalizeClass({
          'exercise-container-content': true,
          isDetail: props.detail
        })
      }, [props.isNested ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString("".concat(props.index, ".")) + "【" + _toDisplayString(_unref(EXERCISE_TYPE_NAME)[props.type]) + "】", 1)) : _createCommentVNode("", true), _createElementVNode("p", {
        innerHTML: props.data.exercise.content
      }, null, 8, _hoisted_5)], 2), _createElementVNode("div", _hoisted_6, [_renderSlot(_ctx.$slots, "tags")]), _renderSlot(_ctx.$slots, "info")], 2);
    };
  }
};